// Nhận diện IP thuộc VPN/CDN (KHÔNG phải mạng văn phòng) để cảnh báo khi khai IP chấm công.
// Vì sao cần: nhân viên bật Cloudflare WARP (1.1.1.1) thì IP public biến thành IP Cloudflare —
// IP đó DÙNG CHUNG TOÀN CẦU. Khai vào danh sách = ai bật WARP ở đâu cũng chấm công được.

// Các dải IPv4 công bố của Cloudflare (gồm cả WARP đi ra) — so khớp theo tiền tố octet.
const CLOUDFLARE_PREFIXES = [
  '103.21.244.', '103.22.200.', '103.31.4.',
  '104.16.', '104.17.', '104.18.', '104.19.', '104.20.', '104.21.', '104.22.', '104.23.',
  '104.24.', '104.25.', '104.26.', '104.27.', '104.28.', '104.29.', '104.30.', '104.31.',
  '108.162.', '131.0.72.', '141.101.', '162.158.', '162.159.', '172.64.', '172.65.',
  '172.66.', '172.67.', '172.68.', '172.69.', '172.70.', '172.71.',
  '173.245.', '188.114.', '190.93.', '197.234.', '198.41.',
];
// Một số dải VPN/proxy phổ biến khác (bổ sung dần khi gặp).
const OTHER_VPN = [
  { name: 'Google VPN / Cloud', prefixes: ['34.', '35.'] },
  { name: 'Amazon AWS', prefixes: ['3.', '52.', '54.', '13.'] },
];

// Trả về { vpn: bool, provider: string, why: string } cho 1 IPv4.
export function vpnIpInfo(ip) {
  const s = String(ip || '').trim();
  if (!/^\d{1,3}(\.\d{1,3}){3}$/.test(s)) return { vpn: false, provider: '', why: '' };
  if (CLOUDFLARE_PREFIXES.some((p) => s.startsWith(p))) {
    return {
      vpn: true,
      provider: 'Cloudflare (WARP / 1.1.1.1)',
      why: 'Máy đang bật VPN WARP nên IP hiện ra là của Cloudflare, không phải mạng công ty. IP này dùng chung toàn cầu — khai vào sẽ cho phép BẤT KỲ AI bật WARP chấm công.',
    };
  }
  for (const g of OTHER_VPN) {
    if (g.prefixes.some((p) => s.startsWith(p))) {
      return {
        vpn: true,
        provider: g.name,
        why: 'IP này thuộc nhà cung cấp máy chủ/VPN, không giống IP internet của văn phòng. Hãy kiểm tra lại (tắt VPN rồi đọc lại IP).',
      };
    }
  }
  return { vpn: false, provider: '', why: '' };
}
